export const Subtitle = ({ title }) => <h3>{title}</h3>
export const FeatImg = ({ img }) => <img className='featured' src={img} alt='blog-featured' />

export const Details = () => (
  <>
    <span>July 10, 2021</span>
    {/* <p>Future implementation- 3 min read</p> */}
    {/* Icon to add favoirite */}
  </>
)
